import React from 'react';
import CharlesSchwab from './charles-schwab';
import CriticalMass from './critical-mass';
import CVSHealth from './cvs-health';
import Deloitte from './deloitte';
import Dropbox from './dropbox';
import Fedex from './fedex';
import GE from './ge';
import Google from './google';
import IBM from './ibm';
import Kroger from './kroger';
import Microsoft from './microsoft';
import MissionLane from './mission-lane';
import NASA from './nasa';
import Oscar from './oscar';
import Pfizer from './pfizer';
import Salesforce from './salesforce';
import SAP from './sap';
import Shopify from './shopify';
import './style.css';
import UnionBank from './union-bank';
import United from './united';
import UniversityOfCambridge from './university-of-cambridge';
import UniversityOfMichigan from './university-of-michigan';
import USBank from './us-bank';
import Volkswagen from './volkswagen';

export default function Companies() {
  // imported twice to make the looping scroll smoother
  return (
    <section
      className="pb-0 pt-10"
      aria-label="Shows some of the companies currently using Stark, such as: Google, Dropbox, Microsoft, United, NASA, and more"
      style={{
        maskImage:
          'linear-gradient(to right, transparent, #000 10% 90%, transparent',
      }}>
      <div>
        <div className="companies__scroll flex w-max items-center overflow-hidden">
          <CharlesSchwab />
          <USBank />
          <United />
          <Shopify />
          <MissionLane />
          <Fedex />
          <UniversityOfMichigan />
          <NASA />
          <SAP />
          <GE />
          <Google />
          <Kroger />
          <UniversityOfCambridge />
          <CVSHealth />
          <CriticalMass />
          <Salesforce />
          <Deloitte />
          <IBM />
          <Dropbox />
          <Oscar />
          <Pfizer />
          <Microsoft />
          <Volkswagen />
          <UnionBank />
          <CharlesSchwab />
          <USBank />
          <United />
          <Shopify />
          <MissionLane />
          <Fedex />
          <UniversityOfMichigan />
          <NASA />
          <SAP />
          <GE />
          <Google />
          <Kroger />
          <UniversityOfCambridge />
          <CVSHealth />
          <CriticalMass />
          <Salesforce />
          <Deloitte />
          <IBM />
          <Dropbox />
          <Oscar />
          <Pfizer />
          <Microsoft />
          <Volkswagen />
          <UnionBank />
        </div>
      </div>
    </section>
  );
}
